import ValidityHint from '@lib/enums/validityHint';

const SEVERITY_ORDER = [
  ValidityHint.Failure,
  ValidityHint.Warning,
  ValidityHint.Success,
];

export default function getWorstValidityHint(
  hints: Array<string | null | undefined>,
): ValidityHint | undefined {
  return SEVERITY_ORDER.find((hint) => hints.includes(hint));
}
